
import Vue from  'vue'
import eventHub from '../../mixins/eventHub'
import {getBounds} from '../../utils/dom/pos.js'

const H_LINE = '<span class="c-horizontal-line u-block u-bg--gold"></span>'


export default {

    props: {
        focus: { type: Boolean, default: true }
    },

    watch: {
        focus(focus)
        {
            this._checkVideoState()
        }
    },

    data()
    {
        return {
            fakeScroll: !this.$root.$children[0].support.touch,
            scrollY: 0,

            hasVideo: !this.$root.$children[0].support.touch,
            isVideoIn: false,
            videoWidth: this.$root.$children[0].windowSize[0],
            videoHeight: Math.round(this.$root.$children[0].windowSize[0] * 9 / 16),

            isScrolling: false,

            phasesContent: [
                [
                    '/Exercise' + H_LINE,
                    'Is&nbsp;A' + H_LINE,
                    'Blessing' + H_LINE
                ],
                [
                    '/Change' + H_LINE,
                    'Leads&nbsp;To' + H_LINE,
                    'Progress' + H_LINE
                ],
                [
                    '/The' + H_LINE,
                    'Mind&nbsp;Is' + H_LINE,
                    'A&nbsp;Muscle' + H_LINE
                ]
            ],
            currentPhase: -1
        }
    },

    created()
    {
        this._elmtToLoad = this.hasVideo ? 1 : 0

        // EVENTS
        this.eventHub.$on('window:resized', this._onResized)

        if (this.fakeScroll)
        {
            this.$root.$children[0].scroll.addOnSmoothScroll(this._scrollY)
        }
        else
        {
            this.$root.$children[0].scroll.addOnScroll(this._scrollY)
        }
    },

    mounted()
    {
        // ADD PROPERTIES
        this._contentElmt = this.$el.querySelector('.js-content')
        this._initPhase()
        this._initBottom()

        // INIT DATAS
        this._scrollY(0)
        this._onResized()
        this._initVideo()

        this._checkAllElmtLoaded()
    },

    destroyed()
    {
        this.eventHub.$off('window:resized', this._onResized)

        if (this.fakeScroll)
        {
            this.$root.$children[0].scroll.removeOnSmoothScroll(this._scrollY)
        }
        else
        {
            this.$root.$children[0].scroll.removeOnScroll(this._scrollY)
        }
    },

    methods: {

        _onElmtLoaded()
        {
            this._elmtToLoad--
            this._checkAllElmtLoaded()
        },

        _checkAllElmtLoaded()
        {
            if (this._elmtToLoad < 1)
            {
                this.eventHub.$emit('page:loaded', this)
            }
        },

        _onResized()
        {
            // SET DOM ELMTS DATAS
            this.videoWidth = this.$root.$children[0].windowSize[0]
            this.videoHeight = Math.round(this.$root.$children[0].windowSize[0] * 9 / 16)


            // GET DOM DATAS
            this._updatePhase()


            // CHANGE DOM DATAS
            this.$root.$children[0].setHeight(this.fakeScroll ? this._contentElmt.offsetHeight : -1)
        },


        /*
                ┌─────────────────────────────────────────────
                │
                │       SCROLL
                │
                └─────────────────────────────────────────────
        */

        _scrollY(posY)
        {
            this.scrollY = posY

            if (this.focus)
            {
                if (this.fakeScroll)
                {
                    this._contentElmt.style.transform = `translateY(-${posY}px) translateZ(0)`
                }

                this._movePhase(posY)
                this._moveBottom(posY)


                this.isScrolling = Math.abs(this.$root.$children[0].scroll.smoothVelocity) > 0.2
            }
        },


        /*
                ┌─────────────────────────────────────────────
                │
                │       VIDEO
                │
                └─────────────────────────────────────────────
        */

        _initVideo()
        {
            this._video = this.$el.querySelector('#exercice-video')
            this._checkVideoState()
        },

        _onVideoIn()
        {
            this.isVideoIn = true
            this._checkVideoState()
        },

        _onVideoOut()
        {
            this.isVideoIn = false
            this._checkVideoState()
        },

        _checkVideoState()
        {
            if (this._video)
            {
                if (this.isVideoIn && this.focus)
                {
                    this._video.play()
                }
                else
                {
                    this._video.pause()
                }
            }
        },


        /*
                ┌─────────────────────────────────────────────
                │
                │       BOTTOM
                │
                └─────────────────────────────────────────────
        */

        _initBottom()
        {
            this._bottomData = {
                textElmt: this.$el.querySelector('.js-nav-bottom'),
                imgElmt: this.$el.querySelector('.js-img-bottom'),
                isOut: true
            }
        },

        _moveBottom( scrollY )
        {
            const root = this.$root.$children[0]
            const scrollMax = root.height - root.windowSize[1]
            const dist = scrollMax - scrollY
            const textDist = dist * 0.5
            const imgDist = dist * 0.2

            this._bottomData.textElmt.style.transform = `translateY(${textDist}px) translateZ(0)`
            this._bottomData.imgElmt.style.transform = `translateY(${imgDist}px) translateZ(0)`
        },


        /*
                ┌─────────────────────────────────────────────
                │
                │       PHASE
                │
                └─────────────────────────────────────────────
        */

        _initPhase()
        {
            const bounds = {x:0, y:0, w:0, h:0}

            this._phaseTitle = {
                elmt: this.$el.querySelector('.js-phase-title'),
                isOut: true// 
            }

            this._phaseContainer = {
                bounds,
                elmt : this.$el.querySelector('.js-phase-container')
            }

            this._phaseParagraph = {
                bounds,
                relY : 0,
                middleElmt : this.$el.querySelector('.js-phase-paragraph-1')
            }
        },

        _updatePhase()
        {
            this._phaseContainer.bounds = getBounds(this._phaseContainer.elmt)
            this._phaseParagraph.bounds = getBounds(this._phaseParagraph.middleElmt)
            this._phaseParagraph.relY = this._phaseParagraph.bounds.y - this._phaseContainer.bounds.y + this._phaseParagraph.bounds.h * 0.5
        },

        _movePhase( scrollY )
        {
            const median = scrollY + this.$root.$children[0].windowSize[1] * 0.5 - (this._phaseParagraph.bounds.y + this._phaseParagraph.bounds.h * 0.5)

            const hMax = this._phaseContainer.bounds.h


            if (Math.abs(median) < 1.5 * hMax)
            {
                const pt = this._phaseTitle
                const offsetY = median * 0.5 + this._phaseParagraph.relY
                pt.elmt.style.transform = `translateY(${offsetY}px) translateY(-50%) translateZ(0)`

                const stateF = median / (0.5 * hMax)
                const state = (stateF < -0.5) ? 0 : (stateF < 0.5) ? 1 : 2


                const oldState = this.currentPhase
                if (state !== oldState)
                {
                    this.currentPhase = state
                }
            }

            this._phaseSetOut( Math.abs(median) > hMax )
        },

        _phaseSetOut( isOut )
        {
            if (isOut && !this._phaseTitle.isOut)
            {
                this._phaseTitle.isOut = true
                this._phaseTitle.elmt.classList.add('is-out')
            }
            else if (!isOut && this._phaseTitle.isOut)
            {
                this._phaseTitle.isOut = false
                this._phaseTitle.elmt.classList.remove('is-out')
            }
        }

    }

}